import { ALPHA_2_ISO_3166 } from 'cpool-constants';
import { z } from 'zod';

export const FPSBankInfo = z
    .object({
        account: z.string().nullish(),
        bankDetails: z
            .object({
                bic: z.string().nullish(),
                city: z.string().nullish(),
                name: z.string().nullish(),
                shortName: z.string().nullish(),
                zip: z.string().nullish(),
            })
            .nullish(),
        bankIndentifier: z.string().nullish(),
        checksum: z.string().nullish(),
        country: z.nativeEnum(ALPHA_2_ISO_3166).nullish(),
    })
    .nullish();

export type Schema_FPSBankInfo = z.infer<typeof FPSBankInfo>;
